import React from "react"
import HtmlParser from "react-html-parser"

export default function QuoteStatementComponent({ statement }) {
  return (
    <blockquote className="quote-statement-container w--normal">
      <aside data-epi-property="Statement" className="quote-statement">
        {HtmlParser(statement)}
      </aside>
    </blockquote>
  )
}
